import { Box, Stack, Typography } from '@mui/material';
import { getLevelFromPoints } from '../../consts/avatarMap';
import Avatar from '../cards/Avatar';
import PointIcon from '../icons/Point';

export default function LeaderboardRow({ rank, name, points, isSelected }) {
    return (
        <Box className={`leaderboard-row ${isSelected ? 'selected' : ''}`}>
            {/* Rank */}
            <Typography variant="body1" sx={{ flex: 1 }}>
                {rank}
            </Typography>

            <Box sx={{ display: 'inline-flex', flex: 4 }}>
                {/* Avatar */}
                <Avatar 
                    level={ getLevelFromPoints(points) }
                    alt={`Rank ${rank}: ${name}'s Avatar`}
                    style={{
                        width: '30px',
                    }}
                />

                {/* Name */}
                <Typography variant="body1">
                    &emsp;{name}
                </Typography>
            </Box>

            {/* Points */}
            <Stack direction={'row'} spacing={2}>
                <Box className="spread-y" sx={{alignItems: 'center', justifyContent: 'center'}}>
                    <Typography variant="body1" >
                        {points}
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: '10px' }}>
                        points
                    </Typography>
                </Box>
                <PointIcon size={24} />
            </Stack>
        </Box>
    );
}
